import { AitHeaderRowData, newHeaderRow } from "aic";
import { headerCellPreProcess } from "./headerCellPreProcess";

/**
 * Normalise header rows and ensure defaults are present.
 *
 * @param defaultCellWidth - Default width to apply to cells
 * @param blank - Blank value used when creating rows
 * @param columnIds - Column ids to use when creating cells
 * @param rs - Optional rows to process
 * @returns Normalised header rows
 */
export const headerRowPreProcess = <T>(
  defaultCellWidth: number,
  blank: T,
  columnIds: string[],
  rs?: AitHeaderRowData<T>[],
): AitHeaderRowData<T>[] => {
  // Return an empty row if there is nothing
  if (rs === undefined) return [newHeaderRow(defaultCellWidth, blank, 0, [])];
  // Check aitid
  return rs.map((r) => ({
    ...r,
    cells: headerCellPreProcess(defaultCellWidth, blank, columnIds, r.cells),
    aitid: r.aitid ?? crypto.randomUUID(),
    spaceAfter: r.spaceAfter ?? false,
    rowRepeat: undefined,
  }));
};
